import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResizeHandle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4141 8L7.99991 22.4142L6.58569 21L20.9999 6.58578L22.4141 8Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4141 15L14.9999 22.4142L13.5857 21L20.9999 13.5858L22.4141 15Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgResizeHandle);
export default ForwardRef;
